import { create } from 'zustand';
import i18n from 'i18n';
import { RegisterApi, RegisterVerifyRequest, RestApiError, StatusCodeEnum } from '@shared/api';
import type { BaseReturn } from '@shared/types';
import { AuthUtils } from '@shared/utils';

interface UseRegisterVerifyStore {
  loading: boolean;
  data: any;
  error?: string | null;
  registerVerify: (request: RegisterVerifyRequest) => Promise<BaseReturn<any>>;
  clear: () => void;
}

export const useRegisterVerifyStore = create<UseRegisterVerifyStore>((set) => ({
  loading: false,
  data: null,
  error: null,

  registerVerify: async (request) => {
    try {
      set({ loading: true, data: null, error: null });
      const result = await RegisterApi.registerVerify(request);
      AuthUtils.setVerifyTempToken(result.registerToken);
      set({ loading: false, data: result ?? null });
      return { loading: false, data: result ?? null };
    } catch (e) {
      const restError = e as RestApiError;

      let errorMessage = 'Something went wrong, try again';
      switch (restError?.status) {
        case StatusCodeEnum.API_ERROR_UNAUTHORIZED:
          errorMessage = 'Invalid confirmation code';
          break;
      }

      const error = i18n.t(`errors.api.${errorMessage}`, errorMessage);
      set({ loading: false, data: null, error });
      return { loading: false, data: null, error };
    }
  },

  clear: () => set({ loading: false, data: null, error: null }),
}));
